import React from 'react';
import { Link } from 'react-router-dom';

const SiteNav = ({ tone = 'light' }) => (
  <nav className={`site-shell-nav site-shell-nav-${tone}`} aria-label="Teddy Marchildon portfolio">
    <Link to="/" className="site-shell-brand">
      <span className="site-shell-mark">TM◆</span>
      <span>Teddy Marchildon</span>
    </Link>
    <Link to="/" className="site-shell-back">
      Portfolio <span aria-hidden="true">↗</span>
    </Link>
  </nav>
);

export default SiteNav;
